<template>
    <div>
        <b-sidebar
            v-if="isSideBarOpenDriverLocal"
            v-model="isSideBarOpenDriverLocal"
            id="sidebar-right"
            title="Добавление водителя"
            right
            backdrop
            shadow
            width="65em"
            backdrop-variant="dark"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <div class="d-block">
                <div class="form-group">
                    <label for="companies">Выберите компанию, к которой будет прикреплен водитель</label>
                    <div class="row px-0">
                        <div class="col-11">
                            <tsoft-select-company
                                :needNullElement="true"
                                @set="setCompanyOfDriver"
                            ></tsoft-select-company>
                        </div>
                        <div class="col-1">
                            <b-button
                                :disabled="(selectedCompanyId != '') ? false:true"
                                size="lg"
                                class="big-add-button"
                                variant="success"
                                title="Добавить"
                                @click="addCompanyToList()"
                            ><b-icon icon="plus" font-scale="1.2"></b-icon></b-button>
                        </div>
                    </div>
                    <template v-if="editedItem.companies.length > 0">
                        <div class="mt-3"><label for="companiesSelected">Водитель привязан к компаниям:</label></div>
                        <div class="row pl-2 py-2" v-for="(company, c_index) in editedItem.companies" :key="company.id">
                            <div class="col-11">- {{ company.name }} ({{ company.inn }})</div>
                            <div class="col-1">
                                <b-button
                                    size="sm"
                                    class="ml-2 mt3px"
                                    variant="danger"
                                    title="Отвязать компанию"
                                    @click="deleteCompanyFromList(c_index)"
                                ><b-icon icon="x" font-scale="1.2"></b-icon></b-button>
                            </div>
                        </div>
                    </template>
                </div>
                <form class="needs-validation mb-1 mt-4" novalidate id="driverForm">
                    <h5 class="my-4">Основная информация</h5>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="lastName">Фамилия</label>
                            <input v-model="lastName" type="text" required class="form-control" id="lastName">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="firstName">Имя</label>
                            <input v-model="firstName" type="text" required class="form-control" id="firstName">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="surName">Отчество</label>
                            <input v-model="surName" type="text" required class="form-control" id="surName">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="phone">Основной телефон</label>
                            <input v-mask="'+# (###) ###-##-##'" v-model="maskPhone" type="text" required class="form-control" id="phone">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="additionalPhone">Дополнительный телефон</label>
                            <input v-mask="'+# (###) ###-##-##'" v-model="maskAdditionalPhone" type="text" class="form-control" id="additionalPhone">
                        </div>
                    </div>

                    <h5 class="my-4">Паспортные данные</h5>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="passport_number">Серия и номер паспорта</label>
                            <input v-mask="'## ## ######'" required v-model="editedItem.passport_number" type="text" class="form-control" id="passport_number">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="new_passport_file_photo">Разворот с фото</label>
                            <b-form-file
                                v-model="editedItem.new_passport_file_photo"
                                :state="Boolean(editedItem.new_passport_file_photo)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.passport_file_photo && !editedItem.new_passport_file_photo">
                                Документ уже был загружен, <a :href="hfs+editedItem.passport_file_photo.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="new_passport_file_address">Разворот с пропиской</label>
                            <b-form-file
                                v-model="editedItem.new_passport_file_address"
                                :state="Boolean(editedItem.new_passport_file_address)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.passport_file_address && !editedItem.new_passport_file_address">
                                Документ уже был загружен, <a :href="hfs+editedItem.passport_file_address.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-8">
                            <label for="passport_issued_by">Кем выдан</label>
                            <input v-model="editedItem.passport_issued_by" type="text" class="form-control" id="passport_issued_by">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="passport_issued_date">Когда выдан</label>
                            <input v-model="editedItem.passport_issued_date" type="date" class="form-control" id="passport_issued_date">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="passport_birth_date">Дата рождения</label>
                            <input v-model="editedItem.passport_birth_date" type="date" class="form-control" id="passport_birth_date">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="passport_birth_town">Город рождения</label>
                            <input v-model="editedItem.passport_birth_town" type="text" class="form-control" id="passport_birth_town">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="passport_checked">Статус проверки</label>
                            <tsoft-select-of-properties
                                :reference_id="44"
                                :needNullElement="false"
                                :needMultipleSelect="false"
                                :defaultSelectName="`Статус проверки`"
                                :internalSearch="false"
                                :selected="editedItem.passport_checked_id"
                                @set="setStatusOfPassport"
                            ></tsoft-select-of-properties>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="passport_address">Адрес регистрация по паспорту</label>
                            <input v-model="editedItem.passport_address" type="text" class="form-control" id="passport_address">
                        </div>
                    </div>

                    <h5 class="my-4">Водительское удостоверение</h5>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="driver_card_number">Серия и номер прав</label>
                            <input v-model="editedItem.driver_card_number" required type="text" class="form-control" id="driver_card_number">
                            <small>Форматы: 1234567890 (только цифры) или 12АА567890 (с русскими заглавными буквами)</small>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="new_driver_card_file_face">Разворот с фото</label>
                            <b-form-file
                                v-model="editedItem.new_driver_card_file_face"
                                :state="Boolean(editedItem.new_driver_card_file_face)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.driver_card_file_face && !editedItem.new_driver_card_file_face">
                                Документ уже был загружен, <a :href="hfs+editedItem.driver_card_file_face.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="new_driver_card_file_back">Разворот оборотной стороны</label>
                            <b-form-file
                                v-model="editedItem.new_driver_card_file_back"
                                :state="Boolean(editedItem.new_driver_card_file_back)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.driver_card_file_back && !editedItem.new_driver_card_file_back">
                                Документ уже был загружен, <a :href="hfs+editedItem.driver_card_file_back.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="driver_card_ends_at">Дата окончания действия прав</label>
                            <input v-model="editedItem.driver_card_ends_at" type="date" class="form-control" id="driver_card_ends_at">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="driver_card_checked">Статус проверки</label>
                            <tsoft-select-of-properties
                                :reference_id="44"
                                :needNullElement="false"
                                :needMultipleSelect="false"
                                :defaultSelectName="`Статус проверки`"
                                :internalSearch="false"
                                :selected="editedItem.driver_card_checked_id"
                                @set="setStatusOfDriverCard"
                            ></tsoft-select-of-properties>
                        </div>
                    </div>
                </form>
            </div>
            <!-- control tabs button -->
            <template #footer>
                <div class="row">
                    <div class="col-9">

                    </div>
                    <div class="col-3 text-right">
                        <button  class="btn btn-outline-primary" @click="submitForm($event)">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import { API_DRIVERS, HOST_FOR_STORAGE } from "../../constants"
import debounce from '../../services/helpers'

import {
    typeOfCompany,
    maxCharsLimit,
    defaultDataItems,
    mixinFIO,
    buildFormData
} from '../../mixins'

export default {
    props: {
        isSideBarOpenDriver: { type: Boolean, required: false },
        editIndex: { type: Number || String, required: false, default: -1 },
        editedItemExt: { type: Object, required: false }
    },
    mixins: [
        typeOfCompany,
        maxCharsLimit,
        defaultDataItems,
        mixinFIO,
        buildFormData
    ],
    data() {
        return {
            tableApiUrl: API_DRIVERS,
            savingProcess: false,
            hfs: HOST_FOR_STORAGE,
            maskPhone: '',
            fieldFIO: 'name',
            maskPhone: '',
            maskAdditionalPhone: '',
            selectedCompanyId: '',
            selectedCompany: {},
        }
    },
    watch: {
        'editedItemExt': function (editedItem){
            this.onItemEditModalCallback()
        },
        'maskPhone': function (phone){
            if (phone) {
                let freshPhone = phone.replace(/[^0-9]/g, '')
                this.editedItem.phone = freshPhone
            }
        },
        'maskAdditionalPhone': function (phone){
            if (phone) {
                let freshPhone = phone.replace(/[^0-9]/g, '')
                this.editedItem.phone_additional = freshPhone
            }
        },
    },
    computed: {
        isSideBarOpenDriverLocal: {
            get: function() {
                return this.isSideBarOpenDriver
            },
            set: function(value) {
                this.$emit('update:isSideBarOpenDriver', value)
            }
        },
        editedItem: {
            get: function() {
                return this.editedItemExt
            },
            set: function(value) {
                this.$emit('update:editedItemExt', value)
            }
        }
    },
    mounted() {
    },
    methods: {
        submitForm(event) {
            event.preventDefault()
            let form = document.getElementById("driverForm")
            if (form.checkValidity() === false) {
                event.preventDefault()
                event.stopPropagation()
                form.classList.add('was-validated')
                return false
            }
            this.createOrUpdateItem()
        },
        createOrUpdateItem() {
            this.savingProcess = true
            if (typeof this.onCreateOrUpdateItemCallback === 'function') {
                this.onCreateOrUpdateItemCallback()
            }

            const formData = new FormData()
            this.buildFormData(formData, this.editedItem)

            if (this.editIndex == -1) {
                api.call("post", this.tableApiUrl, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(({data}) => {
                    this.$emit('create', data)
                    this.savingProcess = false
                    this.isSideBarOpenDriverLocal = false
                    this.makeToast('success', 'Водитель добавлен')
                }).catch((response) => {

                })
            } else {
                formData.append('_method', 'PUT')

                api.call("post", `${this.tableApiUrl}/${this.editedItem.id}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(({data}) => {
                    this.$emit('update', data)
                    this.savingProcess = false
                    this.isSideBarOpenDriverLocal = false
                    this.makeToast('info', 'Изменения в карточке водителя сохранены')
                }).catch((response) => {

                })
            }
        },
        // calls from mixin on item edit
        onItemEditModalCallback() {
            this.maskPhone = ''
            this.maskAdditionalPhone = ''
            this.lastName = ''
            this.firstName = ''
            this.surName = ''
            this.selectedCompanyId = ''
            this.cleanCompanyInfo()

            this.maskPhone = this.editedItem.phone
            this.maskAdditionalPhone = this.editedItem.phone_additional
            this.splitFIO()
        },
        // calls from mixin on item save
        onCreateOrUpdateItemCallback() {
            this.setFIO()
        },
        closeSidePanelCallback() {
            this.$emit('closeSidePanel')
        },
        addCompanyToList() {
            this.editedItem.companies.unshift({
                id: this.selectedCompany.id,
                name: this.selectedCompany.name,
                inn: this.selectedCompany.inn,
            })
            this.selectedCompanyId = ''
            this.cleanCompanyInfo()
        },
        deleteCompanyFromList(index) {
            this.editedItem.companies.splice(index, 1)
        },
        cleanCompanyInfo() {
            for (const prop of Object.getOwnPropertyNames(this.selectedCompany)) {
                delete this.selectedCompany[prop]
            }
        },
        setCompanyOfDriver(id, selectedCompany) {
            if (selectedCompany != null && selectedCompany.id) {
                this.selectedCompanyId = id
                this.selectedCompany = { ...selectedCompany }
            }
        },
        setStatusOfPassport(value) {
            this.editedItem.passport_checked_id = value
        },
        setStatusOfDriverCard(value) {
            this.editedItem.driver_card_checked_id = value
        },
    }
}
</script>
<style scoped>
    .big-add-button {
        height: 50px;
    }
</style>
